import { useState } from "react";

const useCustomFontSize = (defaultFontSize: number = 16) => {
  const [rootFontSize, setRootFontSize] = useState<number>(defaultFontSize);

  const increaseRootFontSize = () => {
    setRootFontSize((prevSize) => prevSize + 2);
    document.documentElement.style.setProperty(
      "--root-font-size",
      `${rootFontSize + 2}px`
    );
  };

  const decreaseRootFontSize = () => {
    setRootFontSize((prevSize) => prevSize - 2);
    document.documentElement.style.setProperty(
      "--root-font-size",
      `${rootFontSize - 2}px`
    );
  };

  const defaultRootFontSize = () => {
    setRootFontSize(defaultFontSize);
    document.documentElement.style.setProperty(
      "--root-font-size",
      `${defaultFontSize}px`
    );
  };

  return {
    rootFontSize,
    increaseRootFontSize,
    decreaseRootFontSize,
    defaultRootFontSize,
  };
};

export default useCustomFontSize;
